import { LevelModel } from '../types/protocols';

/**
 * Level number with a leading zero for single digits: 1 → "01", -1 → "-01",
 * 10 → "10". Same rule as `formatLevelNumber` in Helpers/utils, kept here
 * without that module's UI imports so the API layer and tests can use it.
 */
export const formatLevelNumberPlain = (levelNumber: number): string => {
    if (!Number.isFinite(levelNumber)) return String(levelNumber);
    if (levelNumber < 0) {
        const absNum = Math.abs(levelNumber);
        return absNum < 10 ? `-0${absNum}` : String(levelNumber);
    }
    return levelNumber < 10 ? `0${levelNumber}` : String(levelNumber);
};

/**
 * "<name> (<nr>)" / "Våning <nr>" — the text a level shows everywhere in
 * the app. `LevelImpl.displayName()` delegates here, so the stored lease
 * label for a storage unit uses exactly this string.
 */
export const levelDisplayName = (level: Pick<LevelModel, 'name' | 'number'>): string => {
    const formatted = formatLevelNumberPlain(level.number);
    if (level.name) {
        return `${level.name} (${formatted})`;
    }
    return `Våning ${formatted}`;
};
